import { render, staticRenderFns } from "./Sublimes.vue?vue&type=template&id=1f04e9ec&scoped=true&"
import script from "./Sublimes.vue?vue&type=script&lang=js&"
export * from "./Sublimes.vue?vue&type=script&lang=js&"
import style0 from "./Sublimes.vue?vue&type=style&index=0&id=1f04e9ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04e9ec",
  null
  
)

export default component.exports